import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { INotificationModel } from 'src/app/core/models/interfaces/notification-model';
import { AccountService } from 'src/app/core/services/account.service';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { LoadingService } from 'src/app/core/services/loading.service';

@Component({
  selector: 'app-notification-list',
  templateUrl: './notification-list.component.html',
  styleUrls: ['./notification-list.component.scss'],
})
export class NotificationListComponent implements OnInit {
  groupId: number = 0;
  skipCount: number = 0;
  takeCount: number = 20;
  dateList: string[] = []
  notificationList: { [key: string]: INotificationModel[] } = {}   // { date: string, dataList: INotificationModel[] } = {}
  noNotifications: boolean = false;
  loading: boolean = true;
  databaseError: boolean = false;
  constructor(private accountService: AccountService, private loadingService: LoadingService, private dateTimeService: DateTimeService) { }

  ngOnInit() {
    this.getNotifications().subscribe(resp => {
      if (!(Array.isArray(resp) && resp.length > 0))
        this.noNotifications = true
    })
  }

  getNotifications() {
    this.loading = true;
    let subject = new Subject()
    this.loadingService.showLoading()
    setTimeout(() => {
      this.accountService.GetNotifications(this.skipCount, this.takeCount).subscribe(resp => {
        this.skipCount++;
        this.loading = false;
        if (resp.IsSuccess) {
          if (!Array.isArray(this.dateList))
            this.dateList = [];
          if (Array.isArray(resp.Data) && resp.Data.length > 0) {
            resp.Data.sort((a, b) => DateTimeService.CreateSortFn(a, b, 'NotificationSendDate')).reverse().forEach(el => {
              let date = DateTimeService.FormatDate(el.NotificationSendDate,"YYYY-MM-DD")
              if (!this.dateList.some(t => t === date)) {
                this.dateList.push(date);
              }
              if (!this.notificationList[date]) {
                this.notificationList[date] = [];
              }
              this.notificationList[date].push(el);
            })
            this.dateList.sort((a, b) => {
              let dateA = new Date(a).getTime();
              let dateB = new Date(b).getTime();
              return dateA > dateB ? 1 : dateB == dateB ? 0 : -1
  
            });
            this.databaseError = false;
          }
           this.databaseError = false;
          this.loadingService.hideLoading();
          subject.next(resp.Data);
          subject.complete();
        } else {
          this.loadingService.hideLoading()
          this.databaseError = true;
          subject.next(null);
          subject.complete();
        }
      }, err => {
        this.databaseError = true;
        this.loading = false;
        this.loadingService.hideLoading();
        subject.next(null);
        subject.complete();
      })
    }, 100);
    return subject.asObservable()
  }

  loadData(event) {
    this.getNotifications().subscribe(res => {
      event.target.complete();
      if (!(Array.isArray(res) && res.length > 0)) {
        event.target.disabled = true;
      }
    })
  }


}
